import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ErrorDisplay from "../common/ErrorDisplay";
import LoadingDisplay from "../common/LoadingDisplay";
import { Problem } from "../api/backendApi";
import {
  ChangeSetDataFileModel,
  ChangeSetModel,
  ChangeSetVehicleModel,
  vehicleFileAPI,
} from "../api/vehicleFileAPI";
import { Card, Col, Container, Row } from "react-bootstrap";
import DateDisplay from "../common/DateDisplay";
import ChangeSetDisplay from "./ChangeSetDisplay";
import { useRoutablePages } from "../common/RoutablePages";

function VehicleFileHistoryPage() {
  const params = useParams();
  const number = params.number ?? "";
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Problem | undefined>(undefined);
  const [changeSets, setChangeSets] = useState<ChangeSetModel[]>([]);
  const [checkedOutBy, setCheckedOutBy] = useState<string | undefined>();
  const [currentDataFileChanges, setCurrentDataFileChanges] = useState<
    ChangeSetDataFileModel[]
  >([]);
  const [currentVehicleChanges, setCurrentVehicleChanges] = useState<
    ChangeSetVehicleModel[]
  >([]);
  const routes = useRoutablePages();

  useEffect(() => {
    async function loadHistory(number: string) {
      setLoading(true);
      const data = await vehicleFileAPI.getVehicleFileHistory(number);

      if (data.ok) {
        setError(undefined);

        setCheckedOutBy(data.value.checkedOutBy);
        setCurrentDataFileChanges(data.value.currentFiles);
        setCurrentVehicleChanges(data.value.currentVehicles);
        setChangeSets(data.value.changeSets);
      } else {
        setError(data.problem);
      }

      setLoading(false);
    }
    loadHistory(number);
  }, [number]);

  return (
    <>
      <div className="main-container-title">
        <Row>
          <Col>
            <h1>Vehicle File: {number}</h1>
          </Col>
          <Col md="auto">
            <a href={routes.getVehicleFileDetails(number)}>
              back to vehicle details
            </a>
          </Col>
        </Row>

        <ErrorDisplay error={error} />
        <LoadingDisplay loading={loading} />
      </div>
      {!loading && !error && (
        <div className="main-container-content">
          {currentDataFileChanges.length === 0 &&
            currentVehicleChanges.length === 0 &&
            changeSets.length === 0 && <div>Vehicle file has no changes.</div>}

          <Container>
            {checkedOutBy && (
              <ChangeSetDisplay
                dataFiles={currentDataFileChanges}
                vehicles={currentVehicleChanges}
              >
                <Card.Title>
                  Current changes. Checked out by {checkedOutBy}
                </Card.Title>
              </ChangeSetDisplay>
            )}

            {changeSets.map((cs) => (
              <ChangeSetDisplay
                key={cs.timestamp}
                dataFiles={cs.dataFiles}
                vehicles={cs.vehicles}
              >
                <Card.Title>{cs.message}</Card.Title>
                <Card.Subtitle>
                  {" "}
                  by {cs.userName} on <DateDisplay date={cs.timestamp} />
                  {cs.originalUserName && (
                    <small>forced for {cs.originalUserName}</small>
                  )}
                </Card.Subtitle>
              </ChangeSetDisplay>
            ))}
          </Container>
        </div>
      )}
    </>
  );
}

export default VehicleFileHistoryPage;
